export const REDUCER_NAME = 'PreciousMetals'

export const actions = {
  INITIALIZE: 'PreciousMetals/INITIALIZE',
  REAPPRISE: 'PreciousMetals/REAPPRISE',
}
